import Button from "react-bootstrap/esm/Button"; //"@nokia-csf-uxr/ccfk/Button";
import { pdf } from "@react-pdf/renderer";
import React from "react";
import Dropbox from "../Dropbox";
import SimpleBandBudgetPDF from "../pdf/SingleBandBudgetPDF";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import DualBandBudgetPDF from "../pdf/DualBandBudgetPDF";
import BoQDetailsPDF from "../pdf/BoQDetailsPDF";

/**
 * Export button component
 */
export default class ExportDropbox extends React.Component<any,any> {
    exportTypes: { idExportType: number; label: string; }[];
    exportDropbox: any;

    /**
     * 
     * @param props 
     * - link : Data of the link
     * - chart : Only in dual band to get chart
     */
    constructor(props: any) {
        super(props);
        this.exportTypes = [
            {
                idExportType: 1,
                label: "PDF"
            }
        ];

        this.exportDropbox = this;

        this.state = {
            "export": 0 // Store tje idExporType which is chosen by the user
        };

    }

    /**
     * Generate the PDF
     * WATCH OUT ! When the user click on the button, there is a freeze because of the generation
     */
    exportPDF = async () => {
        var blob;
        if (this.props.linkBoQ == null) {
            if(this.props.link.secondBand != null) {
                console.log(this.props.chart)
                blob = await pdf(<DualBandBudgetPDF link={this.props.link} chart={this.props.chart} />).toBlob();
            } else {
                blob = await pdf(<SimpleBandBudgetPDF link={this.props.link} />).toBlob();
            }   
        } else {
            blob = await pdf(<BoQDetailsPDF link={this.props.link} linkBoQ={this.props.linkBoQ} />).toBlob();
        }

        const pdfURL = URL.createObjectURL(blob);
        window.open(pdfURL, '_blank');
    };

    /**
     * Show the button which corresponds to the chosen export
     * @returns 
     */ //{width: "fit-content"}
    exportButton() {
        if(this.state.export == 1) {
            return (<div style={{overflow: "visible"}} >
            <Button className="menu-button" bsPrefix="" variant="secondary" onClick={() => this.exportPDF()}>Export</Button>
            </div>);
        }
    }

    render() {
        return (<Container className="me-0" style={{width: "fit-content"}}>
            <Row>
                <Col className="me-0 pe-0">
                    { this.exportButton() }
                </Col>
                <Col className="ms-0 ps-0 me-0 pe-5" style={{width: "12em"}}>
                    <Dropbox 
                        uniqueKey="idExportType" 
                        displayInputKey="label"
                        values={this.exportTypes} 
                        showStartedKey={true}
                        startedKey={1}
                        onChange={(newData) => {
                            this.exportDropbox.setState({"export": newData.idExportType})
                        }
                    }
                    /> 
                </Col>
            </Row>
        </Container>)
    }
}